import React, { Component } from "react";
import classnames from "classnames";

import * as styles from "./FlexSpacer.scss";

export interface IFlexSpacerProps {
    className?: string;
}
export class FlexSpacer extends Component<IFlexSpacerProps> {
    public render() {
        const { className } = this.props;
        return <div className={classnames(styles["flex-spacer"], className)} />;
    }
}
